import {Pipe, PipeTransform, OnChanges} from '@angular/core';
import { SETTINGCONFIG } from '../services/configuration';
import { ConfigurationService } from '../services/configuration.service'
import { getCurrencySymbol, formatCurrency } from '@angular/common';
import { CommonService } from 'src/app/shared/services/common.service';
@Pipe({ name: 'currencyformat' })
export class CurrencyFormater implements PipeTransform {
  minimumCurrencyFractionDigits:number = this.commonService.currencyvisibleLength;
  maximumCurrencyFractionDigits:number = this.commonService.currencyvisibleLength;
  minimumCurrencyIntegerDigits:number = this.commonService.currencywholeNumberLength; 
  style: string = 'currency';
  localCurrencyCode: string = 'USD';

  currencyFormat: string = '';
  CurrencyCode: string = '';
  constructor(
    private commonService: CommonService
  ) {
    this.currencyFormat = SETTINGCONFIG.Formats.currencyFormate;
    this.CurrencyCode = SETTINGCONFIG.Formats.CurrencyCode;
  }
  transform(val: any): any {
    let value = val.toString();
      let currencyDigits: any[];
      if (this.currencyFormat != null && this.currencyFormat !== '') {
        currencyDigits = this.currencyFormat.split('.');
      } else if (SETTINGCONFIG.Formats.currencyFormate !== ''){
        currencyDigits = SETTINGCONFIG.Formats.currencyFormate.split('.');
      }
      // this.localCurrencyCode = this.CurrencyCode !== '' && this.CurrencyCode !== null ? 
      // this.CurrencyCode : (SETTINGCONFIG.Formats.CurrencyCode !== ''  && SETTINGCONFIG.Formats.CurrencyCode !== null ? SETTINGCONFIG.Formats.CurrencyCode : this.localCurrencyCode);
      this.localCurrencyCode = this.commonService.Currencies.find(x=>x.Id == (Number(sessionStorage.getItem('BaseCurrencyId'))))?.Code;

      const intergerDigits: string = currencyDigits[0];
      const fractionDigits: string = currencyDigits[1];

      this.minimumCurrencyIntegerDigits = intergerDigits.length <= 0 ?  this.minimumCurrencyIntegerDigits : intergerDigits.length;
      // Fractional Digit values will be coming from logged in site
      // this.minimumCurrencyFractionDigits = fractionDigits.length <= 0 ? this.minimumCurrencyFractionDigits : fractionDigits.length;
      // this.maximumCurrencyFractionDigits = fractionDigits.length <= 0 ? this.maximumCurrencyFractionDigits : fractionDigits.length;
      let digitInfo = this.minimumCurrencyIntegerDigits + '.' + this.minimumCurrencyFractionDigits + '-' + this.maximumCurrencyFractionDigits;

      let currency  = getCurrencySymbol(this.localCurrencyCode, "narrow", 'en');
      value = formatCurrency( parseFloat(value), 'en-US', currency, this.localCurrencyCode, digitInfo);
    return value;
  }
}